<template>
    <div class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center" :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
        <div v-if="this.isMobile">
            <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
        </div>
        <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': this.isMobile }">
            {{ this.$t('components.service.modal.HistoryFilter.1') }}
        </div>
        <div v-if="!this.isMobile">
            <Icon name="close" class="c24 pointer" @click="this.close()"/>
        </div>
    </div>
    <div class="text-black bg-white rounded12" :class="{ 'p-0': this.isMobile, 'p24': !this.isMobile }">
        <div class="d-flex flex-column gap-3 mb24">
            <div v-if="!this.isAdmin || this.fields.uid">
                <div class="fsp14 lh20 neue-roman mb8">{{ this.$t('components.service.modal.HistoryFilter.2') }}</div>
                <SelectSimple
                    id="direction"
                    :defaultValue="this.$t('components.service.modal.HistoryFilter.12')"
                    :keywords="this.directionList"
                    :isFilterSelect="true"
                    :hotUpdate="true"
                    :dataValue="this.fields.direction"
                    @updateParentState="this.updateState"
                />
            </div>
            <div>
                <div class="fsp14 lh20 neue-roman mb8">{{ this.$t('components.service.modal.HistoryFilter.3') }}</div>
                <SelectSimple
                    id="done"
                    :keywords="this.statusList"
                    :hotUpdate="true"
                    :isFilterSelect="true"
                    :defaultValue="this.$t('components.service.modal.HistoryFilter.13')"
                    :dataValue="this.fields.done"
                    @updateParentState="this.updateState"
                />
            </div>
            <div>
                <div class="fsp14 lh20 neue-roman mb8">{{ this.$t('components.service.modal.HistoryFilter.4') }}</div>
                <div class="d-flex align-items-center gap-2">
                    <SelectSimple
                        id="pre_sum"
                        :keywords="this.amountTypeList"
                        :hotUpdate="true"           
                        :defaultValue="this.$t('components.service.modal.HistoryFilter.14')"
                        :dataValue="this.fields.pre_sum"
                        @updateParentState="this.updateState"
                    />
                    <InputSimple
                        id="sum"
                        :placeholder="this.$t('components.service.modal.HistoryFilter.15')"
                        :dataValue="this.fields.sum"
                        @updateParentState="this.updateState"
                        :regCheck="{f: (num) => {
                           return this.$lib.summValidate(num)
                        }}"
                        @focusout="handleFocusOut()"
                    />
                </div>
            </div>
            <div>
                <div class="fsp14 lh20 neue-roman mb8">{{ this.$t('components.service.modal.HistoryFilter.5') }}</div>
                <InputSimple
                    id="transact_num"
                    :placeholder="this.$t('components.service.modal.HistoryFilter.16')"
                    :dataValue="this.fields.transact_num"
                    @updateParentState="this.updateState"
                />
            </div>
            <div v-if="this.isAdmin">
                <div class="fsp14 lh20 neue-roman mb8">{{ this.$t('components.service.modal.HistoryFilter.22') }}</div>
                <InputSimple
                    id="uid"
                    type="number"
                    :placeholder="this.$t('components.service.modal.HistoryFilter.16')"
                    :dataValue="this.fields.uid"
                    @updateParentState="this.updateState"
                    :numOnly="true"
                />
            </div>
            <div>
                <div class="fsp14 lh20 neue-roman mb8">{{ this.$t('components.service.modal.HistoryFilter.6') }}</div>
                <SelectMulti
                    id="command"
                    :keywords="this.operationTypeList"
                    :hotUpdate="true"
                    :isSearch="true"
                    :maxListHeight="280"
                    :defaultValue="this.$t('components.service.modal.HistoryFilter.17')"
                    :dataValue="this.fields.command"
                    @updateParentState="this.updateState"
                />
            </div>
            <div>
                <div class="d-flex align-items-center mb8">
                    <div class="fsp14 lh20 neue-roman">{{ this.$t('components.service.modal.HistoryFilter.7') }}</div>
                    <Popper :hover="true">
                        <Icon name="info" size="c16" class="ml4" />
                        <template #content>
                            <label class="neue-roman fsp14 text-white">{{ this.$t('components.service.modal.HistoryFilter.20') }}</label>
                        </template>
                    </Popper>
                </div>
                <InputSimple
                    id="param"
                    :placeholder="this.$t('components.service.modal.HistoryFilter.18')"
                    :dataValue="this.fields.param"
                    @updateParentState="this.updateState"
                />
            </div>
            <div>
                <div class="fsp14 lh20 neue-roman mb8">{{ this.$t('components.service.modal.HistoryFilter.8') }}</div>
                <InputSimple
                    id="ext_transact_num"
                    :placeholder="this.$t('components.service.modal.HistoryFilter.16')"
                    :dataValue="this.fields.ext_transact_num"
                    @updateParentState="this.updateState"
                />
            </div>
            <div v-if="this.$store.state.userData.passport_serial[0] == 'Service-Member'" class="d-flex align-items-center gap-3 justify-content-between">
                <div class="fsp14 lh20 neue-roman">{{ this.$t('views.History.58') }}</div>
                <SwitchSimple
                    :dataValue="this.fields.show_in_member_accounting_curr" 
                    id='show_in_member_accounting_curr' 
                    @updateParentState="this.updateState"
                />
            </div>
        </div>
        <div class="d-flex align-items-center w-100" :class="{ 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile }">
            <Button type="btn-warning" class="equal-width h48 mr16" @click="this.save()">{{ $t('components.service.modal.HistoryFilter.10') }}</Button>
            <Button type="btn-outline-grey" class="equal-width h48 primary-grey" @click="this.clearAll()">{{ $t('components.service.modal.HistoryFilter.11') }}</Button>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/icons/Icon.vue';
import Button from '@/components/service/Button.vue';
import InputSimple from '../InputSimple.vue';
import SelectSimple from '../SelectSimple.vue';
import SelectMulti from '../SelectMulti.vue';
import Popper from '../Popper.vue';
import SwitchSimple from '@/components/service/SwitchSimple.vue';

export default {
    components: {
        Icon,
        Button,
        SelectSimple,
        SelectMulti,
        InputSimple,
        Popper,
        SwitchSimple
    },
    props: {
        close: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            callback: null,
            defaultFields: {},
            fields: {
                direction: '',
                done: '',
                sum: '',
                transact_num: '',
                uid: '',
                command: '',
                param: '',
                ext_transact_num: '',
                show_in_member_accounting_curr: false,
                pre_sum: '=',
            },
            // Значения = msTransaction DoneEnum (public ?done=). Подписи те же,
            // что в таблице (getStatus), чтобы фильтр и статус строки совпадали.
            statusList: [
                {'code': 'succeeded', value: this.$t('views.History.66')},
                {'code': 'blocking', value: this.$t('views.History.67')},
                {'code': 'declined', value: this.$t('views.History.68')},
                {'code': 'refunded', value: this.$t('views.History.76')},
            ],
            // Значения = msTransaction direction (?direction=). Подписи как в
            // деталях операции (HistoryParams.titleLabel): Приход/Расход/Перевод.
            directionList: [
                {'code': 'inflow', value: this.$t('components.service.modal.History.55')},
                {'code': 'outflow', value: this.$t('components.service.modal.History.56')},
                {'code': 'internal', value: this.$t('components.service.modal.History.57')},
            ],
            amountTypeList: [
                {'code': '=', value: this.$t('views.History.34')},
                {'code': '<>', value: this.$t('views.History.35')},
                {'code': '>', value: this.$t('views.History.36')},
                {'code': '>=', value: this.$t('views.History.37')},
                {'code': '<', value: this.$t('views.History.38')},
                {'code': '<=', value: this.$t('views.History.39')},
            ],
            // Справочник типов операций (реестр commands msTransaction) грузится
            // в created() из GetOperationTypes: [{ code: <command>, value: <name> }].
            operationTypeList: [],
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        },
        isAdmin() {
            return Boolean(this.$store.state.userData.is_admin);
        }
    },
    methods: {
        save() {
            this.callback(this.fields);
            this.close();
        },
        clearAll() {
            this.fields = { ...this.defaultFields };
        },
        handleFocusOut() {
            if((this.fields.pre_sum == '=' || this.fields.pre_sum == '<' || this.fields.pre_sum == '<=') && Number(this.fields.sum) == 0) {
                this.fields.sum = '';
            }
        },
        updateState(state) {
            this.fields[state.id] = state.value;
            if (state.id === 'uid' && !state.value) {
                this.fields.direction = '';
            }
            if(state.id == 'pre_sum') {
                if(state.value == '=' || state.value == '<' || state.value == '<=' && Number(this.fields.sum) == 0) {
                    this.fields.sum = '';
                }
            }
        },
        loadOperationTypes() {
            this.axios.post('GetOperationTypes', { loader: 'none', data: {} }).then(res => {
                const list = (res.data.body && res.data.body.commands) || [];
                this.operationTypeList = list.map(c => ({ code: c.command, value: c.name }));
            }).catch(() => {
                // Реестр команд не загрузился — оставляем фильтр «Тип операции» пустым,
                // не роняя остальные фильтры; глобальный axios-интерсептор покажет ошибку.
                this.operationTypeList = [];
            });
        }
    },
    created() {
        this.defaultFields = Object.assign({}, { ...this.fields, pre_sum: '=' });
        this.fields = this.$store.state.modal.content.fields;
        if(!this.fields.pre_sum) {
            this.fields.pre_sum = '=';
        }
        this.callback = this.$store.state.modal.content.callback;
        this.loadOperationTypes();
    }
}
</script>
